export default "__VITE_ASSET__C3GVw2bN__"